// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var ThirdPartyLogDetailsController = function ($http, $scope, $routeParams, ThirdPartyRequestDetails) {
    $scope.thirdPartyRequestDetails = ThirdPartyRequestDetails.get({ requestId: $routeParams.requestId});

    $scope.parseRequest = function(sourceRequest, shouldTruncate){ 
        var request = copyObject(sourceRequest);
        if(request && request.Request){
            var requestAsJson = JSON.parse(request.Request);
        
            if( isFilled(requestAsJson) && request.ThirdPartyIntegration === 'BlEbics' ) {
                //This block should be used to process each field, which requires additional UI processing
                if(isFilled(requestAsJson.FileContent) && shouldTruncate){
                    requestAsJson.FileContent = "Truncated... See the attached file";
                }
            }
            return requestAsJson;
        }
        else{
            return "";
        }
    }

    $scope.parseResponse = function(sourceRequest, shouldTruncate){
        var request = copyObject(sourceRequest);
        if(request && request.Response){
            var responseAsJson = JSON.parse(request.Response);

            if(responseAsJson && request.ThirdPartyIntegration === 'BlEbics')
            {
                if(isFilled(getPdfFileContent(responseAsJson)) && shouldTruncate){
                    setPdfFileContent(responseAsJson, "Truncated... See the attached file")
                }
                if(responseAsJson && isFilled(responseAsJson.FileContent) && shouldTruncate) {
                    responseAsJson.FileContent = "Truncated... See the attached file";
                }
            }
            return responseAsJson;
        }
        else{
            return "";
        }
    }

    $scope.download = function (request) {

        // The client parsing will be moved to the server side under the ticket IT-10138
        if(request && isFilled(request.ResponseCode) && request.ResponseCode === 200 && isFilled(request.Url) && request.ThirdPartyIntegration === 'BlEbics' ) {

            // PDF initialization file
            if( request.Url.includes('/RegisterUser')) {
                var response = $scope.parseResponse(request, false);
                var pdfFileContent = getPdfFileContent(response);

                if(response && isFilled(pdfFileContent)) {
                    performDownloadAciton('data:application/octet-stream;base64,', pdfFileContent, 'pdf');
                }
            }
            // XML file
            else if(request.Url.includes("/SendFile")){
                var parsedRequest = $scope.parseRequest(request, false);
                if(parsedRequest && isFilled(parsedRequest.FileContent)) {
                    performDownloadAciton('data:application/xml,', parsedRequest.FileContent, 'xml');
                }              
            }
            // XML file
            else if(request.Url.includes("/FetchFile")) {
                var parsedResponse = $scope.parseResponse(request);
                var parsedRequest = $scope.parseRequest(request, false);

                if(parsedRequest && parsedResponse && isFilled(parsedResponse.FileContent)) {
                    if(parsedRequest && (parsedRequest.OrderType === 'HAC' || parsedRequest.OrderType === 'HTD'
                        || parsedRequest.OrderType === 'CRZ' || parsedRequest.OrderType === 'CDZ')) {
                        performDownloadAciton('data:application/xml;base64,', parsedResponse.FileContent, 'xml');
                    }
                    else if(parsedRequest && parsedRequest.OrderType === 'C53'){
                        performDownloadAciton('data:file/zip;base64,', parsedResponse.FileContent, 'zip');
                    }
                    else if(parsedRequest) {
                        alert("Handling is not defined for type = "+parsedRequest.OrderType);
                    }
                }   
            }
        }
    };

    $scope.isResponseContainsFile = function(request) {
        // Building a link to download a response attached file will be moved to the server side under the ticket IT-10138
        return isFilled(request) && 
        request.ThirdPartyIntegration === 'BlEbics' &&
        request.ResponseCode === 200 && 
        (request.Url.includes("RegisterUser") || request.Url.includes("FetchFile")); 
    }

    $scope.isRequestContainsFile = function(request) {
        // Building a link to download a request attached file will be moved to the server side under the ticket IT-10138
        return isFilled(request) &&
        request.ThirdPartyIntegration === 'BlEbics' &&
        request.ResponseCode === 200 && 
        request.Url.includes("SendFile");
    }

    $scope.buildDownloadLink = function(request) {
        var result = "/api/v1/thirdpartyintegrationsrequestlog/download/" + request.Id + "/downloadlink";
        return result;
    }

    const copyObject = function(source) {
        var copy = {};
        Object.keys(source).forEach(function(key) {
            copy[key] = source[key];
        });
        return copy;
    }

    const isFilled = function(input){
        var result = input != null && input != undefined;
        return result;
    }

    const getPdfFileContent = function(requestAsJson) {
        var result = null;
        if(isFilled(requestAsJson) ) {
            if(isFilled(requestAsJson.pdfFileContent)) {
                result = requestAsJson.pdfFileContent;
            }
            else if(isFilled(requestAsJson.PdfFileContent)) {
                result = requestAsJson.PdfFileContent;
            }
        }
        return result;
    }

    const setPdfFileContent = function(responseAsJson, content) {
        if(isFilled(responseAsJson)) {
            if(isFilled(responseAsJson.pdfFileContent)) {
                responseAsJson.pdfFileContent = content;
            }
            else if(isFilled(responseAsJson.PdfFileContent)) {
                responseAsJson.PdfFileContent = content;
            }    
        }
    }

    const performDownloadAciton = function(header, data, extension) {
        var downloadLink = angular.element('<a></a>');
        downloadLink.attr('href', header + data);
        downloadLink.attr('target','_self');
        downloadLink.attr('download',  $routeParams.requestId + '.' + extension);
        downloadLink[0].click();
    }
};

ThirdPartyLogDetailsController.$inject = [ '$http', '$scope', '$routeParams', 'ThirdPartyRequestDetails']; 
